(function(){
  var spoonsPerPot = 71;
  var currentDose = 1;
  var currentPacks = 2;
  var prices = {1:{total:39.90,unit:39.90}, 2:{total:71.82,unit:35.91}, 3:{total:101.76,unit:33.92}};

  function setStepState(n,state){
    var el = document.getElementById('wm-step-'+n);
    if(!el) return;
    el.classList.remove('is-active','is-done','is-locked');
    el.classList.add('is-'+state);
  }
  function goToStep(n){
    for(var i=1;i<=2;i++){
      if(i<n) setStepState(i,'done');
      else if(i===n) setStepState(i,'active');
      else setStepState(i,'locked');
    }
    var el = document.getElementById('wm-step-'+n);
    if(el) setTimeout(function(){el.scrollIntoView({behavior:'smooth',block:'nearest'});},80);
  }
  document.getElementById('wm-step-1-header').addEventListener('click', function(){
    if(document.getElementById('wm-step-1').classList.contains('is-done')) goToStep(1);
  });

  function setS1Summary(sizeLabel){
    document.getElementById('wm-s1-summary').textContent = sizeLabel;
  }
  function refreshS2Summary(){
    var disc = currentPacks===2?10:currentPacks===3?15:0;
    document.getElementById('wm-s2-summary').textContent = currentPacks+' pot'+(currentPacks>1?'s':'')+(disc?' · -'+disc+'%':'');
    document.querySelectorAll('.qb-card').forEach(function(c){
      c.classList.toggle('is-selected', parseInt(c.dataset.packs)===currentPacks);
    });
  }
  function updatePriceDisplay(){
    var p = prices[currentPacks];
    document.getElementById('totalPrice').textContent = p.total.toFixed(2).replace('.',',')+'€';
    document.getElementById('stickyPrice').textContent = 'Total : '+p.total.toFixed(2).replace('.',',')+'€';
  }
  function updateCure(){
    var totalDays = currentDose>0 ? Math.floor((spoonsPerPot*currentPacks)/currentDose) : 0;

    var doseLabel = currentDose === 0.5 ? 'Une demi-cuillère' : (currentDose === 1 ? '1 cuillère' : currentDose + ' cuillères');
    var doseTextEl = document.getElementById('doseCalloutText');
    if(doseTextEl) doseTextEl.textContent = doseLabel + ' par jour';

    var durationTextEl = document.getElementById('durationCalloutText');
    if(durationTextEl) durationTextEl.textContent = 'Cela vous fait ' + totalDays + ' jours de cure';

    updatePriceDisplay();
  }

  document.querySelectorAll('.dog-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.dog-btn').forEach(function(b){b.classList.remove('is-selected');});
      btn.classList.add('is-selected');
      currentDose = parseFloat(btn.dataset.dose);
      setS1Summary(btn.dataset.sizeLabel);
      updateCure();
      setTimeout(function(){ setStepState(2,'active'); goToStep(2); },350);
    });
  });

  document.querySelectorAll('.qb-card').forEach(function(card){
    card.addEventListener('click', function(){
      currentPacks = parseInt(card.dataset.packs);
      refreshS2Summary();
      updateCure();
    });
  });

  // Compteur du quiz d'auto-évaluation
  var quizCheckboxes = document.querySelectorAll('.quiz-checkbox');
  var quizCounterEl = document.getElementById('quizCounter');
  var quizMessageEl = document.getElementById('quizMessage');
  var quizCtaEl = document.getElementById('quizCta');

  // Personnalisation du quiz avec le prénom du chien
  var dogNameInput = document.getElementById('dogNameInput');
  var quizTitleEl = document.getElementById('quizTitle');
  var quizTextEls = document.querySelectorAll('.quiz-text');
  if (dogNameInput) {
    dogNameInput.addEventListener('input', function(){
      var name = dogNameInput.value.trim();
      quizTitleEl.textContent = name ? ('Et ' + name + ', dans tout ça ?') : 'Et votre chien, dans tout ça ?';
      var subject = name || 'Il';
      quizTextEls.forEach(function(el){
        el.textContent = subject + ' ' + el.dataset.base;
      });
    });
  }
  if (quizCheckboxes.length && quizCounterEl) {
    quizCheckboxes.forEach(function(cb){
      cb.addEventListener('change', function(){
        var count = document.querySelectorAll('.quiz-checkbox:checked').length;
        quizCounterEl.textContent = count + (count > 1 ? ' signes cochés' : ' signe coché');

        var msg = '';
        if(count === 0){
          msg = "Aucun signe pour l'instant — c'est justement le bon moment pour agir en prévention.";
        } else if(count <= 2){
          msg = "Ce sont souvent les tout premiers signes — le bon moment pour agir, avant que ça ne s'installe.";
        } else if(count <= 4){
          msg = "Plusieurs signes typiques de gêne articulaire. Une cure de soutien peut faire une vraie différence.";
        } else {
          msg = "De nombreux signes concordants. Mieux vaut agir maintenant qu'attendre que ça s'aggrave.";
        }
        if(quizMessageEl) quizMessageEl.textContent = msg;
        if(quizCtaEl) quizCtaEl.style.display = count >= 1 ? 'inline-block' : 'none';
      });
    });
  }

  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      q.closest('.faq-item').classList.toggle('open');
    });
  });

  document.getElementById('addToCartBtn').addEventListener('click', function(){
    var VARIANT_ID = '57814580986181'; // ID réel de la variante Mobilité & Articulations
    var btn = this;
    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML = 'Ajout en cours...';

    var existingDrawer = document.querySelector('cart-drawer');
    var sectionId = existingDrawer ? existingDrawer.dataset.sectionId : null;

    var payload = { items: [{ id: VARIANT_ID, quantity: currentPacks }] };
    if(sectionId){ payload.sections = sectionId; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res){ return res.json(); })
    .then(function(data){
      btn.disabled = false;
      btn.innerHTML = originalText;

      if(sectionId && data.sections && data.sections[sectionId]){
        // On a récupéré le HTML du panier à jour (avec le nouvel article dedans)
        var parser = new DOMParser();
        var doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');

        if(newDrawer && oldDrawer){
          oldDrawer.replaceWith(newDrawer);
          requestAnimationFrame(function(){ newDrawer.classList.add('is-open'); });
          return;
        }
      }

      // Filet de sécurité si jamais le panier n'a pas pu être retrouvé/remplacé
      var fallbackDrawer = document.querySelector('cart-drawer');
      if(fallbackDrawer){
        fallbackDrawer.classList.add('is-open');
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function(err){
      console.error('Erreur panier :', err);
      btn.disabled = false;
      btn.innerHTML = originalText;
      alert('Erreur lors de l\'ajout au panier. Vérifie que cette page est bien hébergée sur ton domaine Shopify (le fetch /cart/add.js ne fonctionne pas en local).');
    });
  });

  // Copier le code promo dans le presse-papier
  var promoBtn = document.getElementById('promoCopyBtn');
  if (promoBtn) {
    promoBtn.addEventListener('click', function(){
      var code = 'BIENVENUE10';
      var textEl = document.getElementById('promoCopyText');
      var iconEl = document.getElementById('promoCopyIcon');
      var restore = function(){
        promoBtn.classList.remove('is-copied');
        iconEl.textContent = '🎁';
        textEl.textContent = 'Copier le code -10% : BIENVENUE10';
      };
      function showCopied(){
        promoBtn.classList.add('is-copied');
        iconEl.textContent = '✅';
        textEl.textContent = 'Code copié : ' + code;
        setTimeout(restore, 2500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function(){
          textEl.textContent = code;
        });
      } else {
        var tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); showCopied(); } catch(e){ textEl.textContent = code; }
        document.body.removeChild(tmp);
      }
    });
  }

  // init
  document.querySelector('.dog-btn[data-dose="1"]').classList.add('is-selected');
  setS1Summary('- de 20 kg');
  refreshS2Summary();
  updateCure();

  // Affiche la barre sticky mobile uniquement à partir du moment où le sélecteur (section Offre) apparaît à l'écran
  // -- une fois déclenchée, elle reste visible en permanence, même en remontant
  var stickyCta = document.querySelector('.sticky-cta');
  var offreSection = document.getElementById('offre');
  if (stickyCta && offreSection) {
    var stickyObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          stickyCta.classList.add('is-visible');
          stickyObserver.disconnect();
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(offreSection);
  }
})();



// Lecture automatique (sans son) des vidéos dès qu'elles apparaissent à l'écran
(function(){
  var videos = document.querySelectorAll('video.autoplay-on-view');
  if(!videos.length) return;
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var video = entry.target;
      if(entry.isIntersecting){
        video.play().catch(function(){}); // catch : certains navigateurs bloquent encore, pas grave
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 }); // se déclenche quand 50% de la vidéo est visible

  videos.forEach(function(v){ observer.observe(v); });
})();